import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { DataTableCell, DataTableColumn } from "../data-table";
import { ButtonEnums } from "../button";
import { AtlDataTablePlaceholderProps } from "./placeholders.props";

import * as PlaceholderTags from './placeholders.tagnames';
import { SpanPlaceholderSizes } from "./placeholders.enums";

@customElement(PlaceholderTags.DataTable)
export class AtlDataTablePlaceholder extends LitElement implements AtlDataTablePlaceholderProps {
    declare columns: number;
    declare rows: number;
    declare showActionButton?: boolean;
    
    static properties = {
        columns: { type: Number },
        rows: { type: Number },
        showActionButton: { type: Boolean }
    };

    constructor() {
        super();
        this.columns = 3;
        this.rows = 3;
    }

    private _twoColsWidthStyle(colIndex: number) {
        return (colIndex + 1) === 1 && this.columns == 2 ? "45%" : undefined;
    }

    render() {
        const columnValues = Array.from({ length: Math.max(this.columns, 1) }, (i: number) => ({
            styledHead: true,
            content: html`
                <atlantis-span-placeholder size=${SpanPlaceholderSizes.Medium} glow></atlantis-span-placeholder>
                <span class="visually-hidden">Loading Table Heading</span>
            `,
            width: this._twoColsWidthStyle(i)
        } as DataTableColumn));
        
        if (this.showActionButton) {
            columnValues.push({ content: html`<span class="visually-hidden">Button Cell</span>` } as DataTableColumn)
        }

        const rowValues = Array.from({ length: Math.max(this.rows, 1) }, () => {
            const columnValues = Array.from({ length: this.columns }, (i: number) => ({
                content: html`<atlantis-span-placeholder size=${SpanPlaceholderSizes.Small} glow></atlantis-span-placeholder>`,
                width: this._twoColsWidthStyle(i)
            } as DataTableCell));
            if (this.showActionButton) {
                columnValues.push({ 
                    content: html`<atlantis-button variant=${ButtonEnums.ButtonVariant.Action}
                            hiddenText="Loading"
                        >
                            <atlantis-span-placeholder size=${SpanPlaceholderSizes.Smaller} glow></atlantis-span-placeholder>
                        </atlantis-button>` 
                } as DataTableCell);            
            }
            return columnValues;
        });

        return html`
            <atlantis-data-table 
                .columns=${columnValues}
                .rows=${rowValues}
            >
            </atlantis-data-table>
        `;
    }
}